import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'ARQNXS';
const BASE_URL = 'https://www.arqnxs.com';
const DEFAULT_DESCRIPTION =
  'ARQNXS is an Amsterdam technology company specialised in FinTech — proprietary infrastructure as products, IP licensing, and the operation of its own non-custodial DeFi technology.';

const Seo = ({ title, description = DEFAULT_DESCRIPTION, path = '/' }) => {
  const fullTitle = title ? `${title} — ${SITE}` : SITE;
  const url = `${BASE_URL}${path}`;
  return (
    // defer={false} applies tag updates synchronously so react-snap's
    // snapshot can't race ahead of Helmet's animation-frame flush.
    <Helmet defer={false}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
